module.exports = Rx;


/*****************
 ** WEBPACK FOOTER
 ** external "Rx"
 ** module id = 265
 ** module chunks = 0
 **/